export default __webpack_public_path__ + "static/media/cover.131ccc29.png";